let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kzbst")).then(() => parcelRequire('cGJyW'));